// removed by extract-text-webpack-plugin
module.exports = {"root":"Footer__root__31ZV","links":"Footer__links__2HiE","contact":"Footer__contact__2roe"};